export enum SignUpType {
  SENTBIZ = 1,
  FRAUD = 2,
}
